import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query collaborativeFiltering($tenantId: ID!, $suggestionsListId: ID!) {
    collaborativeFiltering(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      count: 50
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
